/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RemoveSchoolAssignment$Params {
  id: string;
  assignmentId: string;
}

export function removeSchoolAssignment(http: HttpClient, rootUrl: string, params: RemoveSchoolAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeSchoolAssignment.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('assignmentId', params.assignmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeSchoolAssignment.PATH = '/school/{id}/assignments/{assignmentId}';
